import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'bca-route-summary',
  templateUrl: 'route-summary.component.html',
  styleUrls: ['route-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteSummaryComponent {
  @Input()
  secondClassPrice: number;
  @Input()
  trainFreePrice: number;
}
